import { render, staticRenderFns } from "./groupTaskClaimed.vue?vue&type=template&id=c9bd2690"
import script from "./groupTaskClaimed.vue?vue&type=script&lang=js"
export * from "./groupTaskClaimed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports